import { render } from "./BaseButton.vue?vue&type=template&id=74333eea&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=74333eea&scoped=true&lang=css"

import exportComponent from "/Users/yuseung-u/Downloads/GaGeNow-FrontEnd-0dadc1419985eb3bcabe16f2f57804c1aafc4152/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74333eea"]])

export default __exports__